import React from 'react';
import Navbar from "../Components/Navbar";

import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import "./membership.css";
import "./Profile.css";
import FileBase64 from 'react-file-base64';
import store from "../store/index";
import i18n from '../i18n';
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';
import pool from "../img/pool.JPG";
import track from "../img/track.JPG";
import football from "../img/football.JPG";
import gym from "../img/gym.JPG";
import stad from "../img/stad.JPG";
import logo from "../img/logo1.png";
const devicedetails = {
    "imei": "862188038288320",
    "deviceOSVersion": "6.0.1",
    "uuid": "862188038288320",
    "deviceModel": "NOKIA 100",
    "deviceManufacturer": "Xiaomi",
    "serviceProvider": "airtel",
    "deviceOS": "ANDROID",
    "ipAddress": "192.168.43.210"
}
const headers = {
    "RequestMode": "0",
    "UserID": localStorage.getItem('userid'),
    "BearerKey": "Mobile",
    "ServiceId": "SERV!",
    "SessionId": localStorage.getItem(ACCESS_TOKEN_NAME),
    "Locale": "E/A",
    "DeviceDet": devicedetails

}

const slideImages = [
    pool,
    gym,
    football,
    stad
];


class MembershipForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            pageIndex: 0,
            image: 'https://apollo-ireland.akamaized.net/v1/files/db4igty87gxq3-OM/image;s=644x461;olx-st/_1_.jpg',
            document: '',
            documentId: '',
            membership_type: "STUDENT",
            name: localStorage.getItem('username'),
            nationality_id: "OMAN",
            dob: "",
            lang: 'ar',
            work_place: "",
            imageindex: 0,
            occupation: "",
            resident_place: "",
            mobile_no: localStorage.getItem('userEmail'),
            email_id: localStorage.getItem('userPhone'),
            gender: "MALE",
            duration: "6",
            civil_id: "",
            countries: [],
            locations: [],
            stadiums: [],
            facilities: [],
            mtypes: [],
            mtype: '',
            mduration: '',
            location: '',
            stadium: '',
            isActive: false,
            membership_status: '',
            document_status: '',
            medical_document_status: '',
            approve_status: '',
            membership_expiry_date: '',
            errors: {}
        };


        this.setTabIndexDetails = this.setTabIndexDetails.bind(this)
        this.setTabIndexPay = this.setTabIndexPay.bind(this)
        this.setState = this.setState.bind(this);
        this.getFiles = this.getFiles.bind(this);
        this.getFilesDoc = this.getFilesDoc.bind(this);

        //  localStorage.removeItem(ACCESS_TOKEN_NAME)


    }
    getFiles(file) {
        this.setState({ document: file })
    }
    getFilesDoc(file) {
        this.setState({ documentId: file })
    }
    setTabIndexDetails = () => {
        this.setState({ tabIndex: 0 });
    }
    setTabIndexDoc = () => {

        if (this.state.membership_status !== 'Membership not Completed') {
            this.setState({ tabIndex: 1 });

        } else {
            let self = this;
            Swal.fire({
                text: "Please wait for the membership request to be approved",
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok'
            });
        }
    }
    setTabIndexPay = () => {

        if (this.state.membership_status != 'Membership not Completed' && this.state.medical_document_status != 'Medical certificate not uploaded' &&
            this.state.document_status != 'Documents not uploaded') {
            this.setState({ tabIndex: 2 });

        } else {
            let self = this;
            Swal.fire({
                text: "Please complete Step 1 and Step 2 to proceed to Payment",
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok'
            });
        }
    }
    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    // mySubmitHandler = (event) => {

    //         event.preventDefault();

    //         if(this.handleValidation){

    //                 console.log("NOW ... You are submitting " + JSON.stringify(this.state));
    //                 this.handleMembership();

    //         }else{
    //            console.log("Form has errors.")
    //         }
    // }

    mySubmitHandler = (event) => {

        event.preventDefault();



        let errors = {};
        let formIsValid = true;


        //this.props.history.push('/validate');
        if (!this.state.name) {
            formIsValid = false;
            errors["name"] = "Please enter your name";
        }
        if (!this.state.dob) {
            formIsValid = false;

            errors["dob"] = "Please enter Date of Birth";
        }
        if (!this.state.occupation) {
            formIsValid = false;

            errors["occupation"] = "Please enter Occupation";
        }
        if (!this.state.occupation) {
            formIsValid = false;

            errors["occupation"] = "Please enter Occupation";
        }
        if (!this.state.civil_id) {
            formIsValid = false;

            errors["civil_id"] = "Please enter Civil ID/Passport";
        }
        if (!this.state.resident_place) {
            formIsValid = false;

            errors["resident_place"] = "Please enter Residence Place";
        }



        this.setState({ errors: errors });
        if (formIsValid) {

            console.log("NOW ... You are submitting " + JSON.stringify(this.state));
            this.handleMembership();

        } else {
            console.log("Form has errors.")
        }

    }
    handleMembership = () => {



        const payload = {
            "membership_type": this.state.mtype,
            "name": this.state.name,
            "nationality_id": this.state.nationality_id,
            "dob": this.state.dob,
            "work_place": this.state.work_place,
            "occupation": this.state.occupation,
            "resident_place": this.state.resident_place,
            "mobile_no": localStorage.getItem('userPhone'),
            "email_id": localStorage.getItem('userEmail'),
            "gender": this.state.gender,
            "duration": this.state.mduration,
            "civil_id": this.state.civil_id,
            "stadium_id": this.state.stadium,
            "location_id": this.state.location,
            "rate": this.state.cost,

        }

        // redirectToHome();
        const mosa = { "mast": payload, ReqHead: headers }
        // console.log('calling api ...' + JSON.stringify(payload));
        let self = this; //  declared var welcom

        console.log('calling api ...' + JSON.stringify(mosa));
        this.setState({ isActive: true });

        axios.post(API_MOSA_URL + '/User/NewMembershipInsert', mosa)
            .then(function (response) {
                console.log(JSON.stringify(response));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {
                    if (response.data[0].StatusCode == "0") {
                        Swal.fire({
                            title: 'Success',
                            text: 'Your membership request is submitted',
                            allowOutsideClick: false,
                            icon: 'success',
                            confirmButtonText: 'Ok'
                        }).then((result) => {
                            if (result.value) {
                                window.location.reload(false);

                            }
                        })
                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }


                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });




    }
    changePage = (event, page) => {
        if (page == 1) {
            if (!this.state.location) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Please select location!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            } else if (!this.state.stadium) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Please select stadium!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            } else if (!this.state.mtype) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Please select Membership Type!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            } else if (!this.state.mduration) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Please select duration!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            } else {
                this.setState({ pageIndex: page });
            }
        }

    }
    membershipTypes = () => {

        // alert( event.target.value);
        // this.setState({ isActive: true });
        headers.lang = this.state.lang;
        const mosa = { ReqHead: headers }
        let self = this;

        axios.post(API_MOSA_URL + '/User/MembershipTypeGetList', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data[1]));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ mtypes: response.data[1] });
                        //window.scrollTo(0, 0);

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });
    }
    getRate = (dur) => {


        this.setState({ isActive: true });
        headers.lang = this.state.lang;
        const mosa = { ReqHead: headers, stadium_id: this.state.stadium, location_id: this.state.location, membership_type_id: this.state.mtype, duration: dur }
        let self = this;
        console.log('calling api .. ' + JSON.stringify(mosa));

        axios.post(API_MOSA_URL + '/User/MembershipTypeRateGet', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data[1]));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {
                        self.setState({ isActive: false });

                        self.setState({ cost: response.data[1] });


                    } else {
                        self.setState({ isActive: false });

                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    this.setState({ isActive: false });

                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });

    }
    change = (event) => {

        // alert( event.target.value);
        this.setState({ isActive: true });
        headers.lang = this.state.lang;
        if (event.target.value !== '0') {
            this.setState({ location: event.target.value });
            const mosa = { ReqHead: headers, "location_id": event.target.value }
            let self = this;

            axios.post(API_MOSA_URL + '/User/GetStadiumListByLocation', mosa)

                .then(function (response) {
                    console.log(JSON.stringify(response.data));
                    // self.redirectToValidate();
                    self.setState({ isActive: false });

                    if (response.status === 200) {

                        if (response.data[0].StatusCode == "0") {

                            self.setState({ stadiums: response.data[1] });
                            self.setState({ stadium: '' });
                            self.setState({ mtype: '' });
                            self.setState({ mduration: '' });
                            self.setState({ cost: '' });

                            //window.scrollTo(0, 0);

                        } else {
                            Swal.fire({
                                title: 'Error!',
                                text: response.data[0].Message,
                                icon: 'error',
                                confirmButtonText: 'Ok'
                            })
                        }

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: 'Please try again later!',
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                })
                .catch(function (error) {
                    console.log(error);
                    self.setState({ isActive: false });
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })

                });
        } else {
            this.setState({ location: '' });
            this.setState({ stadium: '' });
            this.setState({ mtype: '' });
            this.setState({ mduration: '' });

            this.setState({ isActive: false });

        }
    }
    stadiumChange = (event) => {


        console.log(JSON.stringify(event.target.value));
        if (event.target.value === '0') {
            this.setState({ stadium: '' });
            this.setState({ mtype: '' });
            this.setState({ mduration: '' });
            this.setState({ cost: '' });

        }
        else {
            this.setState({ stadium: event.target.value });
            this.setState({ mtype: '' });
            this.setState({ mduration: '' });
            this.setState({ cost: '' });


        }
    }
    changeMDuration = (event) => {

        console.log('duration ... ' + JSON.stringify(event.target.value));
        if (event.target.value === '0') {
            this.setState({ mduration: '' });
            this.setState({ cost: '' });

        }
        else {
            this.setState({ mduration: event.target.value });
            this.setState({ cost: '' });
            this.getRate(event.target.value);
        }
    }
    changeMType = (event) => {

        if (event.target.value === '0') {
            this.setState({ mtype: '' });
            this.setState({ mduration: '' });
            this.setState({ cost: '' });

        }
        else {
            this.setState({ mtype: event.target.value });
            this.setState({ mduration: '' });
            this.setState({ cost: '' });


        }
        var selection = this.state.mtypes.find(item => item.membership_type_mast_id === event.target.value);
        console.log("selected .... " + JSON.stringify(selection));

    }
    handleSubmitFile = () => {
        this.setState({ isActive: true });
        headers.lang = this.state.lang;
        if (this.state.document !== null && this.state.document.length != 0) {


            const payload = {
                document: this.state.document,
                ReqHead: headers
            }

            const mosa = { "mast": payload }
            let self = this; //  declared var welcom

            console.log('calling api ...' + JSON.stringify(payload));
            this.setState({ isActive: true });

            axios.post(API_MOSA_URL + '/User/UpdateMedicalCertificateID', payload)
                .then(function (response) {
                    console.log(JSON.stringify(response));
                    // self.redirectToValidate();
                    self.setState({ isActive: false });

                    if (response.status === 200) {
                        if (response.data[0].StatusCode == "0") {
                            Swal.fire({
                                title: 'Success',
                                text: 'Your medical document has been submitted',
                                allowOutsideClick: false,
                                icon: 'success',
                                confirmButtonText: 'Ok'
                            }).then((result) => {
                                if (result.value) {
                                    localStorage.setItem('enableeditprofile', false);
                                    window.location.reload(false);

                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Error!',
                                text: response.data[0].Message,
                                icon: 'error',
                                confirmButtonText: 'Ok'
                            })
                        }


                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: 'Please try again later!',
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                })
                .catch(function (error) {
                    console.log(error);
                    self.setState({ isActive: false });
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })

                });


        }
        else {
            this.setState({ isActive: false });

            Swal.fire({
                title: 'Error!',
                text: 'Please attach a valid Medical Certificate',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
    }

    handleSubmitIdProof = () => {
        this.setState({ isActive: true });

        if (this.state.documentId !== null && this.state.documentId.length != 0) {


            const payload = {
                document: this.state.documentId,
                ReqHead: headers
            }

            const mosa = { "mast": payload }
            let self = this; //  declared var welcom

            console.log('calling api ...' + JSON.stringify(payload));
            this.setState({ isActive: true });

            axios.post(API_MOSA_URL + '/User/UpdateDocument', payload)
                .then(function (response) {
                    console.log(JSON.stringify(response));
                    // self.redirectToValidate();
                    self.setState({ isActive: false });

                    if (response.status === 200) {
                        if (response.data[0].StatusCode == "0") {
                            Swal.fire({
                                title: 'Success',
                                text: 'Your  document ID Proof has been submitted',
                                allowOutsideClick: false,
                                icon: 'success',
                                confirmButtonText: 'Ok'
                            }).then((result) => {
                                if (result.value) {
                                    localStorage.setItem('enableeditprofile', false);
                                    window.location.reload(false);

                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Error!',
                                text: response.data[0].Message,
                                icon: 'error',
                                confirmButtonText: 'Ok'
                            })
                        }


                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: 'Please try again later!',
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                })
                .catch(function (error) {
                    console.log(error);
                    self.setState({ isActive: false });
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })

                });


        }
        else {
            this.setState({ isActive: false });

            Swal.fire({
                title: 'Error!',
                text: 'Please attach a valid ID Proof',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
    }

    loadLocations() {

        window.scrollTo(0, 0);

        let self = this; //  declared var welcom
        headers.lang = this.state.lang;
        this.setState({ isActive: true });
        const mosa = { ReqHead: headers }


        axios.post(API_MOSA_URL + '/User/GetLocationList', mosa)

            .then(function (response) {
                //console.log(JSON.stringify(response.data.data));
                // self.redirectToValidate();
                // self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ locations: response.data[1] });
                        self.setState({ cost: '' });

                        window.scrollTo(0, 0);
                        self.loadCountries();
                        // self.membershipTypes();

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                        self.setState({ isActive: false });
                    }

                } else {
                    self.setState({ isActive: false });
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });

    }

    loadCountries() {

        window.scrollTo(0, 0);

        let self = this; //  declared var welcom
        headers.lang = this.state.lang;
        this.setState({ isActive: true });
        const mosa = { ReqHead: headers }


        axios.post(API_MOSA_URL + '/User/GetCountryList', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data[1]));
                // self.redirectToValidate();
                // self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ countries: response.data[1] });
                        self.setState({ cost: '' });

                        window.scrollTo(0, 0);
                        self.membershipTypes();

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                        self.setState({ isActive: false });
                    }

                } else {
                    self.setState({ isActive: false });
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });

    }

    timer() {
        console.log('timer check .. ');
        if (this.state.imageindex == 0) {
            this.setState({
                imageindex: 1
            });
        } else if (this.state.imageindex == 1) {
            this.setState({
                imageindex: 2
            });
        }
        else {
            this.setState({
                imageindex: 0
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        this.intervalId = setInterval(this.timer.bind(this), 3000);

        this.setState({ isActive: true });

        headers.lang = this.state.lang;
        const payload = {
            ReqHead: headers
        }
        //localStorage.setItem(ACCESS_TOKEN_NAME,'response.data.token');
        let self = this; //  declared var 

        // redirectToHome();

        axios.post(API_MOSA_URL + '/User/GetMembershipDetails', payload)
            .then(function (response) {
                self.setState({ isActive: false });
                self.loadLocations();

                console.log(JSON.stringify(response));

                if (response.status === 200) {
                    //this.props.history.push('/validate');
                    if (response.data[0].StatusCode == "0") {
                        self.setState({ membership_status: response.data[2].membership_status });
                        self.setState({ document_status: response.data[2].document_status });
                        self.setState({ medical_document_status: response.data[2].medical_document_status });
                        self.setState({ approve_status: response.data[0].approve_status });

                        if (response.data[2].membership_status != 'Membership not Completed' &&
                            (response.data[2].medical_document_status == 'Medical certificate not uploaded' || response.data[2].document_status == 'Documents not uploaded')) {
                            self.setState({ tabIndex: 1 });
                        }
                        else if (response.data[2].membership_status != 'Membership not Completed' &&
                            (response.data[2].medical_document_status != 'Medical certificate not uploaded' && response.data[2].document_status != 'Documents not uploaded')) {
                            self.setState({ tabIndex: 2 });
                        }
                        window.scrollTo(0, 0)

                    }
                    else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        }).then((result) => {
                            if (result.value) {
                                self.props.history.push('/login');
                            }
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });

                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
            });
    }
    render() {
        let self = this;
        store.subscribe(() => {
            console.log('change lang' + store.getState().lang);
            localStorage.setItem('lang', store.getState().lang)

            self.setState({ lang: localStorage.getItem('lang') });
        });

        let locations = this.state.locations;
        let optionItems = locations.map((location) =>
        
         <option value={location.location_mast_id}>{this.state.lang=='ar' && location.location_name_ar}{this.state.lang=='en' && location.location_name_en}</option>
        );

        let stadiums = this.state.stadiums;
        let stadItems = stadiums.map((stadium) =>
            <option value={stadium.stadium_mast_id}>{this.state.lang=='ar' && stadium.stadium_name_ar}{this.state.lang=='en' && stadium.stadium_name_en}</option>
        );

        let crs = this.state.countries;
        let crsItems = crs.map((ctype) =>
            <option value={ctype.country_id}>{this.state.lang=='en' && ctype.country_en}{this.state.lang=='ar' && ctype.country_ar}</option>
        );

        let mtypes = this.state.mtypes;
        let mtItems = mtypes.map((mtype) =>
            <option value={mtype.membership_type_mast_id}>{this.state.lang=='en' && mtype.membership_type_name_en}{this.state.lang=='ar' && mtype.membership_type_name_ar}</option>
        );
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner
                text='Loading ...'
            >
                <div style={{ backgroundColor: '#dfe6e9' }}>


                    <Navbar page={2} />
                    {/* {this.state.imageindex == 0 && */}
                        <div className="all-title-box  wow fadeIn" style={{ 'backgroundImage': `url(${slideImages[2]})` }}>
                            <div className="container text-center">
                                {this.state.membership_status != 'Membership not Completed' &&
                                    (this.state.medical_document_status === 'Medical certificate not uploaded' ||
                                        this.state.document_status === 'Documents not uploaded') &&
                                    <h1 style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK25', this.state.lang)}<span className="m_1">{i18n.t('JK72', this.state.lang)}</span></h1>
                                }
                                {this.state.membership_status == 'Membership not Completed' &&
                                    <h1 style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK25', this.state.lang)}<span className="m_1">{i18n.t('JK141', this.state.lang)}</span></h1>
                                }
                            </div>
                        </div>
                    {/* } */}
                    {/* {this.state.imageindex == 1 &&
                        <div className="all-title-box  wow fadeIn" style={{ 'backgroundImage': `url(${slideImages[1]})` }}>
                            <div className="container text-center">
                                {this.state.membership_status != 'Membership not Completed' &&
                                    (this.state.medical_document_status === 'Medical certificate not uploaded' ||
                                        this.state.document_status === 'Documents not uploaded') &&
                                    <h1 style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK25', this.state.lang)}<span className="m_1">{i18n.t('JK72', this.state.lang)}</span></h1>
                                }
                                {this.state.membership_status == 'Membership not Completed' &&
                                    <h1 style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK25', this.state.lang)}<span className="m_1">{i18n.t('JK141', this.state.lang)}</span></h1>
                                }
                            </div>
                        </div>
                    }
                     {this.state.imageindex == 2 &&
                        <div className="all-title-box  wow fadeIn" style={{ 'backgroundImage': `url(${slideImages[2]})` }}>
                            <div className="container text-center">
                                {this.state.membership_status != 'Membership not Completed' &&
                                    (this.state.medical_document_status === 'Medical certificate not uploaded' ||
                                        this.state.document_status === 'Documents not uploaded') &&
                                    <h1 style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK25', this.state.lang)}<span className="m_1">{i18n.t('JK72', this.state.lang)}</span></h1>
                                }
                                {this.state.membership_status == 'Membership not Completed' &&
                                    <h1 style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK25', this.state.lang)}<span className="m_1">{i18n.t('JK141', this.state.lang)}</span></h1>
                                }
                            </div>
                        </div>
                    } */}

                    {this.state.tabIndex == 0 &&
                        <section className="testimonial py-3" id="testimonial">
                            <div className="">
                                <div className="row " style={{ backgroundColor: 'white' }}>
                                    <div className="col-md-4 py-5  text-white text-center " style={{ backgroundColor: '#2d6302 ' }}>
                                        <div className=" ">
                                            <div className="card-body">
                                                <img src="http://www.ansonika.com/mavia/img/registration_bg.svg" style={{ width: '30%' }} />
                                                <h2 className="py-3" style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK142', this.state.lang)}</h2>
                                                <p style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK143', this.state.lang)}
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8 py-5 border">
                                        {this.state.pageIndex == 0 &&
                                            <div className="" >

                                                <div className="card-body" style={{ minHeight: '300px' }}>
                                                    <div className="">
                                                        <div className="row">
                                                            <div className="col-sm-12 col-md-12">
                                                                {
                                                                    this.state.membership_status == 'Membership not Completed' &&
                                                                    <div className="text-left alert-message alert-message-warning">
                                                                        <h4 style={{ fontFamily: 'Tajawal' }}>
                                                                            {i18n.t('JK144', this.state.lang)}</h4>
                                                                        <p style={{ fontFamily: 'Tajawal' }}>
                                                                            {i18n.t('JK145', this.state.lang)}</p>
                                                                    </div>
                                                                }
                                                                {
                                                                    this.state.membership_status != 'Membership not Completed' &&
                                                                    <div className="text-left alert-message alert-message-success">
                                                                        <h4 style={{ fontFamily: 'Tajawal' }}>
                                                                            {i18n.t('JK144', this.state.lang)}</h4>
                                                                        <p style={{ fontFamily: 'Tajawal' }}>
                                                                            {i18n.t('JK146', this.state.lang)}</p>
                                                                    </div>
                                                                }


                                                            </div>
                                                        </div>


                                                        <div className="form-group row">
                                                            <div className="col-md-5 text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK147', this.state.lang)}</label><br />
                                                                <select className="btn btn-outline-secondary dropdown-toggle" style={{ width: '100%' }} onChange={this.change} value={this.state.location}>
                                                                    <option value={'0'}>{i18n.t('JK148', this.state.lang)}</option>
                                                                    {optionItems}
                                                                </select>
                                                            </div>
                                                            <div className="col-md-5 text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK149', this.state.lang)}</label><br />
                                                                <select disabled={!this.state.location || this.state.location.length == 0} className="btn btn-outline-secondary dropdown-toggle" style={{ width: '100%' }} id="exampleFormControlSelect1" onChange={this.stadiumChange} value={this.state.stadium}>
                                                                    <option value={'0'}>{i18n.t('JK150', this.state.lang)}</option>
                                                                    {stadItems}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="form-group row">
                                                            <div className="col-md-5 text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK151', this.state.lang)}</label><br />
                                                                <select disabled={!this.state.stadium} className="btn btn-outline-secondary dropdown-toggle" style={{ width: '100%' }} onChange={this.changeMType} value={this.state.mtype}>
                                                                    <option value={'0'}>{i18n.t('JK151', this.state.lang)}</option>
                                                                    {mtItems}
                                                                </select>
                                                            </div>

                                                            <div className="col-md-5 text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK153', this.state.lang)}</label><br />
                                                                <select disabled={!this.state.mtype} className="btn btn-outline-secondary dropdown-toggle" style={{ width: '100%' }} onChange={this.changeMDuration} value={this.state.mduration}>
                                                                    <option value={'0'}>{i18n.t('JK153', this.state.lang)}</option>
                                                                    <option value={'Six Month'}>{i18n.t('JK154', this.state.lang)}</option>
                                                                    <option value={'One Year'}>{i18n.t('JK155', this.state.lang)}</option>
                                                                </select>
                                                            </div>


                                                        </div>

                                                        <div className="form-group row">
                                                            <div className="col-md-6">
                                                                <h4 className="text-left text-muted" style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK156', this.state.lang)} </h4>
                                                            </div>
                                                            <div className="col-md-6 text-left" style={{ fontFamily: 'Tajawal' }}>
                                                                {this.state.cost &&
                                                                    <h4><span style={{ color: "orange", fontSize: '20px' }}>OMR {this.state.cost}</span></h4>
                                                                }
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6  text-lg-center">


                                                    </div>
                                                    <div className="col-lg-6 text-lg-center">
                                                        <button className="btn btn-light btn-radius btn-brd grd1" onClick={e => this.changePage(e, 1)}>{i18n.t('JK19', this.state.lang)} </button>
                                                    </div>
                                                </div>



                                            </div>
                                        }
                                        {this.state.pageIndex == 1 &&
                                            <form className="form" onSubmit={this.mySubmitHandler}>

                                                <div className="card-body" style={{ minHeight: '300px' }}>
                                                    <div className="">
                                                        <div className="row" style={{ backgroundColor: 'white' }}>
                                                            <div className="col-sm-12 col-md-12">
                                                                {
                                                                    this.state.membership_status == 'Membership not Completed' &&
                                                                    <div className="text-left alert-message alert-message-warning">
                                                                        <h4 style={{ fontFamily: 'Tajawal' }}>
                                                                            {i18n.t('JK144', this.state.lang)} </h4>
                                                                        <p style={{ fontFamily: 'Tajawal' }}>
                                                                            {i18n.t('JK145', this.state.lang)}</p>
                                                                    </div>
                                                                }
                                                                {
                                                                    this.state.membership_status != 'Membership not Completed' &&
                                                                    <div className="text-left alert-message alert-message-success">
                                                                        <h4 style={{ fontFamily: 'Tajawal' }}>
                                                                            {i18n.t('JK144', this.state.lang)} </h4>
                                                                        <p style={{ fontFamily: 'Tajawal' }}>
                                                                            {i18n.t('JK146', this.state.lang)}</p>
                                                                    </div>
                                                                }


                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK157', this.state.lang)}</label>
                                                                <input type="text"
                                                                    disabled={true}
                                                                    name="mobile_no" placeholder={i18n.t('JK157', this.state.lang)} defaultValue={localStorage.getItem('userPhone')} className="form-control" />
                                                            </div>
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK31', this.state.lang)}</label>
                                                                <input type="email"
                                                                    disabled={true}
                                                                    name="email_id" placeholder={i18n.t('JK31', this.state.lang)} defaultValue={localStorage.getItem('userEmail')} className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK158', this.state.lang)}</label>
                                                                <input
                                                                    type="text"
                                                                    disabled={true}
                                                                    name="name"
                                                                    value={this.state.name}
                                                                    defaultValue={localStorage.getItem('username')}
                                                                    placeholder={i18n.t('JK158', this.state.lang)}
                                                                    className="form-control"
                                                                    onChange={this.myChangeHandler} />
                                                            </div>
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK159', this.state.lang)}</label>
                                                                <input type="text"
                                                                    className="form-control"
                                                                    name="occupation"
                                                                    value={this.state.occupation}
                                                                    placeholder={i18n.t('JK159', this.state.lang)}
                                                                    onChange={this.myChangeHandler} />
                                                                <span className="form-text" style={{ color: 'red' }}>{this.state.errors["occupation"]}</span>
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK160', this.state.lang)}</label><br />
                                                                {/* <select className="form-control " onChange={this.myChangeHandler} name="nationality_id">
                                                                    <option value="OMAN">{i18n.t('JK161', this.state.lang)}</option>
                                                                    <option value="EXPAT">{i18n.t('JK162', this.state.lang)}</option>
                                                                </select> */}
                                                                <select className="form-control " onChange={this.myChangeHandler} name="nationality_id">
                                                                    <option value={'0'}>{i18n.t('JK160', this.state.lang)}</option>
                                                                    {crsItems}
                                                                </select>
                                                            </div>
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK163', this.state.lang)}</label>
                                                                <input type="text" name="civil_id" onChange={this.myChangeHandler} placeholder={i18n.t('JK163', this.state.lang)} className="form-control" />
                                                                <span className="form-text" style={{ color: 'red' }}>{this.state.errors["civil_id"]}</span>
                                                            </div>
                                                        </div>

                                                        <div className="form-group row">
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK165', this.state.lang)}</label><br />
                                                                <input type="date" name="dob" onChange={this.myChangeHandler} placeholder={i18n.t('JK165', this.state.lang)} className="form-control" />
                                                                <span className="form-text" style={{ color: 'red' }}>{this.state.errors["dob"]}</span>
                                                            </div>
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK167', this.state.lang)}</label>
                                                                <select className="form-control" onChange={this.myChangeHandler} name="gender" >
                                                                    <option value="MALE">{i18n.t('JK168', this.state.lang)}</option>
                                                                    <option value="FEMALE">{i18n.t('JK169', this.state.lang)}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="form-group row">
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK170', this.state.lang)}</label><br />
                                                                <input type="text" name="work_place" onChange={this.myChangeHandler} placeholder={i18n.t('JK171', this.state.lang)} className="form-control" />

                                                                <span className="form-text" style={{ color: 'red' }}>{this.state.errors["work_place"]}</span>
                                                            </div>
                                                            <div className="col text-left">
                                                                <label style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK172', this.state.lang)}</label>
                                                                <input type="text" name="resident_place" onChange={this.myChangeHandler} placeholder={i18n.t('JK173', this.state.lang)} className="form-control" />
                                                                <span className="form-text" style={{ color: 'red' }}>{this.state.errors["resident_place"]}</span>
                                                            </div>
                                                        </div>


                                                    </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6  text-lg-center">

                                                        <button type="button" onClick={e => this.setState({ pageIndex: 0 })} className="btn btn-light btn-radius btn-brd grd1">{i18n.t('JK18', this.state.lang)}</button>

                                                    </div>
                                                    <div className="col-lg-6 text-lg-center">
                                                        <button type="submit" className="btn btn-light btn-radius btn-brd grd1">{i18n.t('JK174', this.state.lang)}</button>
                                                    </div>
                                                </div>



                                            </form>
                                        }
                                    </div>

                                </div>
                            </div>
                        </section>
                    }
                    {this.state.tabIndex == 1 &&
                        <section className="testimonial py-3" id="testimonial">
                            <div className="">
                                <div className="row ">
                                    <div className="col-md-4 py-5  text-white text-center " style={{ backgroundColor: '#4c5a7d ' }}>
                                        <div className=" ">
                                            <div className="card-body">
                                                <img src="http://www.ansonika.com/mavia/img/registration_bg.svg" style={{ width: '30%' }} />
                                                <h2 className="py-3" style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK142', this.state.lang)}</h2>
                                                <p style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK143', this.state.lang)}
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8 py-5 border" style={{ backgroundColor: 'white' }}>
                                        <form className="form" onSubmit={this.mySubmitHandler}>
                                            <div className="card-body ">
                                                <div className="row" >
                                                    <div className="col-sm-12 col-md-12 ">
                                                        {this.state.medical_document_status == 'Medical certificate not uploaded' &&
                                                            <div className="alert-message alert-message-warning">
                                                                <h4 style={{ fontFamily: 'Tajawal' }}>
                                                                    {i18n.t('JK73', this.state.lang)}</h4>
                                                                <p style={{ fontFamily: 'Tajawal' }}>
                                                                    {i18n.t('JK74', this.state.lang)}</p>
                                                            </div>
                                                        }
                                                        {
                                                            this.state.medical_document_status != 'Medical certificate not uploaded' &&
                                                            <div className="alert-message alert-message-success">
                                                                <h4 style={{ fontFamily: 'Tajawal' }}>
                                                                    {i18n.t('JK215', this.state.lang)}</h4>
                                                                <p style={{ fontFamily: 'Tajawal' }}>
                                                                    {i18n.t('JK216', this.state.lang)}</p>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="row" >
                                                    <div className="col-sm-6">
                                                        <div className="form-group">
                                                            <div className="col-xs-6">

                                                                <div className="form-control"><FileBase64
                                                                    multiple={false}
                                                                    onDone={this.getFiles} /></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <div className="form-group">
                                                            <div className="col-xs-6">

                                                                <div className="text-center">
                                                                    <button className="btn  btn-brd grd1"
                                                                        type="button"
                                                                        disabled={this.state.medical_document_status != 'Medical certificate not uploaded'}
                                                                        onClick={this.handleSubmitFile}
                                                                        style={{}}>
                                                                        <i className="glyphicon glyphicon-ok-sign" />
                                                                        {i18n.t('JK77', this.state.lang)}
                                                                    </button>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-12">
                                                        <hr />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <hr />
                                                    <div className="col-sm-12 col-md-12">
                                                        {this.state.document_status == 'Documents not uploaded' &&

                                                            <div className="alert-message alert-message-warning">
                                                                <h4 style={{ fontFamily: 'Tajawal' }}>
                                                                    {i18n.t('JK75', this.state.lang)} </h4>
                                                                <p style={{ fontFamily: 'Tajawal' }}>
                                                                    {i18n.t('JK76', this.state.lang)}</p>
                                                            </div>
                                                        }
                                                        {this.state.document_status != 'Documents not uploaded' &&

                                                            <div className="alert-message alert-message-success">
                                                                <h4 style={{ fontFamily: 'Tajawal' }}>
                                                                    {i18n.t('JK219', this.state.lang)}</h4>
                                                                <p style={{ fontFamily: 'Tajawal' }}>
                                                                    {i18n.t('JK220', this.state.lang)} </p>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="row ">
                                                    <div className="col">
                                                        <div className="form-group">

                                                            <div className="col-xs-6">
                                                                <div className="form-control">
                                                                    <FileBase64
                                                                        multiple={false}
                                                                        onDone={this.getFilesDoc} />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col">
                                                        <div className="form-group">
                                                            <div className="col-xs-6">
                                                                <div className="text-center">
                                                                    <button className="btn  btn-brd grd1"
                                                                        type="button"
                                                                        disabled={this.state.document_status != 'Documents not uploaded'}
                                                                        onClick={this.handleSubmitIdProof}
                                                                        style={{}}>
                                                                        <i className="glyphicon glyphicon-ok-sign" />
                                                                        {i18n.t('JK78', this.state.lang)}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <br />
                                            </div>

                                        </form>
                                    </div>

                                </div>
                            </div>
                        </section>
                    }
                    {this.state.tabIndex == 2 &&
                        <section className="testimonial py-3" id="testimonial">
                            <div className="">
                                <div className="row ">
                                    <div className="col-md-4 py-5  text-white text-center " style={{ backgroundColor: '#4c5a7d ' }}>
                                        <div className=" ">
                                            <div className="card-body">
                                                <img src="http://www.ansonika.com/mavia/img/registration_bg.svg" style={{ width: '30%' }} />
                                                <h2 className="py-3">Facility  Membership</h2>
                                                <p>Please apply for membership in three simple steps.
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8 py-5 border">
                                        <form className="form" onSubmit={this.mySubmitHandler}>

                                        </form>
                                    </div>

                                </div>
                            </div>
                        </section>
                    }

                </div>
                <Footer />
            </LoadingOverlay >)
    }
}

export default MembershipForm; 